import { Dispatch, SetStateAction, useState } from 'react';

import { SortOrder } from '@/types/enum/sort-order';
import { SortController } from '@/types/interfaces/sort-controller';

interface Params {
  sortOrder?: SortOrder;
  sortBy?: string;
}

export type SetSortController = Dispatch<SetStateAction<SortController>>;

type ReturnType = [SortController, SetSortController];

export const useSortController = ({
  sortOrder = SortOrder.DESC,
  sortBy = 'from',
}: Params = {}): ReturnType => {
  const [sortController, setSortController] = useState<SortController>(() => ({
    sortOrder: sortOrder,
    sortBy: sortBy,
  }));

  return [sortController, setSortController];
};
